import { defineComponent as a, createElementBlock as n, openBlock as p, normalizeProps as i, guardReactiveProps as s, unref as m, renderSlot as l } from "vue";
import { useChildrenTracker as c } from "../../use/children-tracker.js";
import { FormSelectOptionsKey as u } from "./FormSelect.vue2.js";
import { useOUIAProps as f } from "../../helpers/ouia.js";
const O = /* @__PURE__ */ a({
  name: "PfFormSelectOption",
  __name: "FormSelectOption",
  props: {
    placeholder: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(e) {
    const o = e, r = f({ id: o.ouiaId, safe: o.ouiaSafe });
    return c(u), (t, d) => (p(), n("option", i(s(m(r))), [
      l(t.$slots, "default")
    ], 16));
  }
});
export {
  O as default
};
